export const MAP_CONFIG = {
  defaultZoom: 11,
  minZoom: 1,
  maxZoom: 18,
  // Zoom used when framing a single focused venue — district scale.
  focusZoom: 14,
  // Ceiling when fitting bounds around several pins (e.g. hotel → venue), so
  // close pairs read like the strip-level route view rather than street level.
  fitMaxZoom: 15,
}

/** Pixel padding kept around markers when auto-fitting bounds. */
export const AUTO_FIT_PADDING_PX = 100

export const mapClasses = {
  tooltipWrapper: 'gm-style-iw',
  tooltipWrapperD: 'gm-style-iw-d',
  tooltipWrapperTc: 'gm-style-iw-tc',
}

export const MILES_UNIT_CONVERSION = {
  feet: 5280,
  yards: 1760,
  meters: 1609.34,
  kilometers: 0.621371,
}
